import { useEffect, useRef, useState } from 'react'
import Icon from '../../components/icons.jsx'
import ActivityDeadlinePicker from '../comercial/ActivityDeadlinePicker.jsx'
import { REPORT_PERIODS } from '../../lib/reportPeriods.js'
import '../comercial/dealPanel.css'

const display = value => value.split('-').reverse().join('/')

export default function ReportPeriodPicker({ value, onChange }) {
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState(value)
  const [calendarRevision, setCalendarRevision] = useState(0)
  const root = useRef(null)
  const trigger = useRef(null)
  const popup = useRef(null)
  const selected = REPORT_PERIODS.find(item => {
    const range = item.range(new Date())
    return range.from === value.from && range.to === value.to
  })
  useEffect(() => {
    if (!open) return
    popup.current?.querySelector('button')?.focus()
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false) }
    document.addEventListener('pointerdown', outside)
    return () => document.removeEventListener('pointerdown', outside)
  }, [open])
  const close = () => { setOpen(false); trigger.current?.focus() }
  return <div className="oe-period-picker" ref={root} onKeyDown={event => {
    if (open && event.key === 'Escape') { event.stopPropagation(); close() }
  }}>
    <button ref={trigger} type="button" className="oe-period-trigger" aria-label="Período" aria-haspopup="dialog" aria-expanded={open} title={`${display(value.from)} – ${display(value.to)}`}
      onClick={() => { setDraft(value); setCalendarRevision(v => v + 1); setOpen(v => !v) }}>
      <Icon n="calendar" s={14} /><span>{selected?.label || `${display(value.from)} – ${display(value.to)}`}</span><Icon n="chevron_d" s={12} />
    </button>
    {open && <div ref={popup} className="oe-period-popup" role="dialog" aria-label="Selecionar período">
      <div className="oe-period-body">
        <div className="oe-period-presets" role="group" aria-label="Períodos rápidos">{REPORT_PERIODS.map(item => {
          const range = item.range(new Date())
          return <button type="button" key={item.id} aria-pressed={draft.from === range.from && draft.to === range.to}
            onClick={() => { setDraft(range); setCalendarRevision(v => v + 1) }}>{item.label}</button>
        })}</div>
        <div className="oe-period-calendars">{[['from', 'Data inicial'], ['to', 'Data final']].map(([key, label]) => <section className="oe-period-calendar dp-activity-popover" role="group" aria-label={label} key={key}>
          <header><strong>{label}</strong><span>{display(draft[key])}</span></header>
          <ActivityDeadlinePicker key={calendarRevision} value={draft[key]} dateOnly allowClear={false} onChange={date => setDraft(current => ({ ...current, [key]: date }))} />
        </section>)}</div>
      </div>
      <footer>{draft.from > draft.to && <span role="alert">A data final deve ser igual ou posterior à inicial.</span>}
        <button type="button" onClick={close}>Cancelar</button><button type="button" disabled={draft.from > draft.to} onClick={() => { onChange(draft); close() }}>Aplicar</button>
      </footer>
    </div>}
  </div>
}
